// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3tiB4","productName":"Table_productName__2s7F4"};